import * as React from "react"
import styled from "styled-components"
import TinySlider from "tiny-slider-react";
import '../../../css/tiny-slider.css';
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

const CarouselControlsWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 480px;
  margin: 0 auto 2rem;

  @media (max-width: 425px) {
    flex-direction: column;
    align-items: center;
    margin-bottom: 0;
  }
`

const StyledSection = styled.section`
  background-color: #d6e1ef;
  padding: 5rem 2rem;
  text-align: left;
  text-wrap: pretty;
  font-weight: 500;
  position: relative;

  .tns-slider {
    padding-top: 40px;
    display: flex;
    align-items: stretch;
  }
`

const Quote = styled.div({
  maxWidth: "480px",
  margin: "0 auto 20px",
  fontSize: `18px`,
  lineHeight: `1.5`,
})

const Cite = styled.p({
  fontSize: `22px`,
  fontWeight: `800`,
  textAlign: `left`,
  marginTop: `auto`,
})

const CenterPosition = styled.div`
  position: absolute;
  top: -40px;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
`
const Dot = styled(GatsbyImage)`
  display: block;
  width: 80px;
  height: 80px;
  border: 1px solid #566885;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
`;

const Spacer = styled.div`
  padding: 0.75rem;
`;

const Card = styled.div`
  background: #fff;
  padding: 3rem 2.5rem 2rem;
  position: relative;
  border-radius: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Testimony = () => {
  const data = useStaticQuery(graphql`
  query Testimonies {
    # selecting the current post by id
    fields: wpPage(isFrontPage: { eq: true }) {
      footerSettingsFields {
        testimonies {
          heading
          testimonies {
            testimony
            name
            image {
              node {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 160
                      placeholder: BLURRED
                      formats: [AUTO, WEBP, AVIF]
                    )
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  `)

  const heading = data.fields.footerSettingsFields.testimonies.heading;
  const testimonies = data.fields.footerSettingsFields.testimonies.testimonies;

  const sliderSettings = {
    swipeAngle:false,
    items:1,
    responsive:{
      596: {
        items: 2
      },
      956: {
        items: 3
      },
    },
    mouseDrag: true,
    lazyload:false,
    controlsContainer:".testimonies-tns-controls",
    controls:false
  }

  return (
    <StyledSection>
      <CarouselControlsWrap>
        <h2>{heading}</h2>
        
      </CarouselControlsWrap>
      {typeof window !== 'undefined' && (
      <TinySlider
        settings={sliderSettings}
        onGoTo={dir => this.ts.slider.goTo(dir)}
      >
        {testimonies.map((testimony, i) => (
          <Spacer key={`testimony${i}`}>
            <Card>
              <CenterPosition>
                <Dot
                  image={ testimony.image.node.localFile.childImageSharp.gatsbyImageData }
                  alt={ testimony.image.node.altText }
                />
              </CenterPosition>
              <Quote>{ testimony.testimony }</Quote>
              
              <Cite>{ testimony.name }</Cite>
            </Card>
          </Spacer>
        ))}
      </TinySlider>
      )}
    </StyledSection>
  )
}

export default Testimony
